import React, { useEffect, useState } from 'react';
import { fetchUpcomingEvents } from '@/lib/api';
import { splitHomepageEvents } from '@/lib/eventAdapter';
import EventsCarouselSection from '@/app/components/EventsCarouselSection';

export default function HomeEventsSections() {
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [passedEvents, setPassedEvents] = useState([]);
    const [loadError, setLoadError] = useState('');

    useEffect(() => {
        fetchUpcomingEvents()
            .then((events) => {
                const { upcoming, passed } = splitHomepageEvents(events);
                setUpcomingEvents(upcoming);
                setPassedEvents(passed);
            })
            .catch(() => {
                setLoadError('Unable to load events. Please try again later.');
                setUpcomingEvents([]);
                setPassedEvents([]);
            });
    }, []);

    return (
        <>
            <EventsCarouselSection
                id="events"
                ariaLabel="Upcoming events"
                sectionLabel="Upcoming Events"
                title="Unmissable Experiences"
                events={upcomingEvents}
                loadError={loadError}
                emptyMessage="No upcoming events right now."
                className={passedEvents.length > 0 ? '!pb-6 lg:!pb-8' : ''}
            />
            {passedEvents.length > 0 ? (
                <EventsCarouselSection
                    id="past-events"
                    ariaLabel="Past events"
                    sectionLabel="Past Events"
                    title="Recent Performances"
                    events={passedEvents}
                    emptyMessage="No past events to show."
                    className="!pt-0 lg:!pt-2"
                />
            ) : null}
        </>
    );
}
